"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5c4.334 0 7.212.104 8.469.162.685.031 1.35.468 1.465 1.19.037.233.066.514.066.822 0 .31-.029.59-.066.824-.115.72-.78 1.158-1.465 1.189-1.258.057-4.135.162-8.469.162s-7.212-.105-8.469-.162c-.685-.031-1.35-.468-1.465-1.19a5.253 5.253 0 0 1 0-1.646c.115-.72.78-1.158 1.465-1.19C4.788 3.605 7.666 3.5 12 3.5Zm0 6.326c4.334 0 7.212.104 8.469.162.685.03 1.35.468 1.465 1.189a5.254 5.254 0 0 1 0 1.647c-.115.72-.78 1.157-1.465 1.188-1.258.058-4.135.162-8.469.162s-7.212-.104-8.469-.162c-.685-.03-1.35-.468-1.465-1.189a5.252 5.252 0 0 1 0-1.646c.115-.721.78-1.158 1.465-1.19 1.257-.057 4.135-.16 8.469-.16Zm8.469 6.487c-1.258-.057-4.135-.162-8.469-.162s-7.212.105-8.469.162c-.685.031-1.35.468-1.465 1.19a5.252 5.252 0 0 0 0 1.646c.115.72.78 1.158 1.465 1.19 1.257.057 4.135.161 8.469.161s7.212-.104 8.469-.162c.685-.031 1.35-.468 1.465-1.19.037-.233.066-.514.066-.822 0-.31-.029-.59-.066-.824-.115-.72-.78-1.158-1.465-1.189Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBurger);
var _default = exports["default"] = Memo;